module.exports = __webpack_public_path__ + "static/Ape-594c795880b13eeab6ef3e73fc95ef33.jpg";